import { Project } from './project';
import { User } from './user';
import * as global from '../global';
export class Enterprise {
	id: string;
	name: string;
	shortName: string;
	projects: Project[];
	users: User[];
	type: string;
	constructor(users, type) {
		this.id = global.generateRandomString(-1);
		this.users = users;
		this.type = type;
		if (this.type == 'private') {
			this.name = this.shortName = 'Personal';
		}
		this.projects = [new Project()];
	}
}



// WEBPACK FOOTER //
// D:/OneDrive/Dev/firebase/alagatime_bootstrap/src/app/.modal/enterprise.ts